import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useNavigate } from 'react-router-dom';

function List() {
  const profileFilter = chooseProfileFilter();
  const navigate = useNavigate();

  const pathFrontEnd = '/bankinghistories/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
    endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
    endpointDelete: config.endpoints.backend + 'filebankinghistories/delete',
    endpoint: config.endpoints.backend + 'filebankinghistories/getall'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      !profileFilter.pdc_entity_id ? {
        name: 'pdc_entity_id',
        type: 'select',
        label: 'Entidade',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllEntities,
          label: 'corporate_name',
          value: 'id',
          params: {
            filter: {
              ...profileFilter
            }
          }
        },
        validations: {
          required: false
        },
        columnSize: 3,
      } : {},
      {
        name: 'pdc_project_id',
        type: 'select',
        label: 'Projeto',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllProjects,
          label: 'project_name',
          value: 'id',
          params: {
            filter: {
              ...profileFilter
            }
          }
        },
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ]
  }

  let list = {
    labelTitle: 'Lista de Importações de Extratos Bancários',
    labelTitleButtonAdd: 'Importar',
    fieldsShowOnDelete: ['entity_name'],
    showPrintButtons: true,
    canAdd: false,
    canEdit: false,
    canView: false,
    formFilters: filters,
    filter: {
      ...profileFilter
    },
    columns: [
      {
        name: 'entity_name',
        label: 'Entidade',
      },
      {
        name: 'project_name',
        label: 'Projeto',
      },
      {
        name: 'account',
        label: 'Conta Bancária',
      },
      {
        name: 'imported_period',
        label: 'Período',
        width: '20%'
      },
      {
        name: 'imported_begin',
        label: 'Início em',
      },
      {
        name: 'imported_finish',
        label: 'Finalizado em',
      },
      {
        name: 'formatted_status',
        label: 'Status',
      }
    ],
    buttonsListContainer: [
      {
        name: 'go_back_banking_histories',
        class: 'btn btn-secondary',
        label: 'Voltar',
        tooltipLabel: 'Histórico',
        callback: async () => {
          navigate(`/bankinghistories/competencies`)
        }
      }
    ],
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        buttons={list.buttonsListContainer}
        canAdd={list.canAdd}
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default List;
